module.exports = __webpack_public_path__ + "img/jennifer_gibson_expert_exchanges_credit_likhaan_1.12bfc7a6.jpg";